import { useContext } from 'react';

import { VehicleCardConfigProp, VehicleCardContext } from './VehicleCard';
import VehicleCardInvoiceMobile from './VehicleCardInvoiceMobile';
import VehicleCardMobileV2 from './VehicleCardMobileV2';
import VehicleCardShowroomMobile from './VehicleCardShowroomMobile';

interface VehicleCardMobileProps {
  style: object;
  config: VehicleCardConfigProp;
}

const VehicleCardMobile = ({ style, config }: VehicleCardMobileProps) => {
  const { isShowroomMode, showingInvoicing } = useContext(VehicleCardContext);

  if (showingInvoicing) {
    return <VehicleCardInvoiceMobile />;
  }

  if (isShowroomMode) {
    return <VehicleCardShowroomMobile style={style} config={config} />;
  }

  return <VehicleCardMobileV2 />;
};

export default VehicleCardMobile;
